import workspaceQuery from '../../../graphql/queries/web/StaticBoxWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/web/StaticBoxQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';
import defaultQuery from '../../../graphql/queries/web/StaticBoxDefault.graphql';
import mutationQuery from '../../../graphql/mutations/web/StaticBoxMutation.graphql';

const StaticBox: EntityType = {
  type: 'StaticBox',
  title: 'Static Blocks',
  formTitle: 'Static Block',
  formUrl: '/Web/StaticBox/Details/',
  workspaceUrl: '/Web/StaticBox/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  screenReference: 'STATIC_BOX',
};
export default StaticBox;
